import axios from 'axios';

export default {
  state: {
    historybuy_detail: {},
    historybuy_detailLoading: false,
    historybuy_detailError: null,
    historybuy_detailLoaded: false,
    noMoreOrder_detail: false
  },
  mutations: {
    SET_HISTORYBUY_DETAIL(state, historybuy_detail) {
      state.historybuy_detail = historybuy_detail;
      state.historybuy_detailLoaded = true; // Устанавливаем флаг, что данные загружены
    },
    SET_HISTORYBUY_DETAIL_LOADING(state, status) {
      state.historybuy_detailLoading = status;
    },
    UNSET_HISTORYBUY_DETAIL(state) {
      state.historybuy_detailLoaded = false;
      state.historybuy_detailLoading = false;
      state.historybuy_detail = {};
    },
    SET_HISTORYBUY_DETAIL_ERROR(state, error) {
      state.historybuy_detailError = error;
    }
  },
  actions: {
    async fetchHistoryBuy_detail({ commit, state }, id) {
      commit('UNSET_HISTORYBUY_DETAIL');
      commit('SET_HISTORYBUY_DETAIL_LOADING', true);
      try {
        // Используем относительный путь, который будет добавлен к baseURL из глобальных настроек
        const response = await axios.get('api/historybuy/'+id+'/');
        if (response.data.status == 'error') {
          commit('SET_HISTORYBUY_DETAIL_ERROR', 'Заказ не найден');
        }
        else {

          commit('SET_HISTORYBUY_DETAIL', response.data.data);
          commit('SET_HISTORYBUY_DETAIL_ERROR', null);
        }
      } catch (error) {
        commit('SET_HISTORYBUY_DETAIL_ERROR', error.message || 'Ошибка при загрузке');
        console.error('Error fetching historybuy_detail:', error);
      } finally {
        commit('SET_HISTORYBUY_DETAIL_LOADING', false);
      }
    }
  },
  getters: {
    historybuy_detail: state => state.historybuy_detail,
    historybuy_detailLoading: state => state.historybuy_detailLoading,
    historybuy_detailError: state => state.historybuy_detailError,
    historybuy_detailLoaded: state => state.historybuy_detailLoaded
  }
}